import { dispatcher, services } from '@ambita/ambita-components-core';
import { fetchBrokerLetterReportData } from '../dataServices/cadastreReport';
import * as brokerLetterReportConstants from '../constants/brokerLetterReport';

const { dispatch } = dispatcher;
const { log } = services;
const { actions: brokerLetterReportActions } = brokerLetterReportConstants;

const setBrokerLetterReportDataLoading = (): void => {
  dispatch({
    actionType: brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_LOADING
  });
};

const setBrokerLetterReportDataLoaded = (data: any): void => {
  dispatch({
    actionType: brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_LOADED,
    data
  });
};

const setBrokerLetterReportDataFailed = (error: any): void => {
  dispatch({
    actionType: brokerLetterReportActions.BROKER_LETTER_REPORT_DATA_FAILED,
    error
  });
};

export const getBrokerLetterReportData = (cadastreKey: string): void => {
  setBrokerLetterReportDataLoading();

  fetchBrokerLetterReportData(cadastreKey)
    .then(setBrokerLetterReportDataLoaded)
    .catch(error => {
      setBrokerLetterReportDataFailed(error);
      log.error('Getting broker letter report data failed. Cause:', error);
    });
};
